import { EarlyAccessFeature } from 'posthog-js';
import { useEffect, useState } from 'react';
import { useActiveFeatureFlags, usePostHog } from 'posthog-js/react';

export function useEarlyStageFeatures() {
  const [features, setFeatures] = useState<EarlyAccessFeature[]>([]);
  const posthog = usePostHog();
  const activeFlags = useActiveFeatureFlags();

  useEffect(() => {
    posthog.getEarlyAccessFeatures(eaf => {
      setFeatures(eaf);
    }, true);
  }, []);
  return {
    features,
    updateEarlyAccessFeatureEnrollment: (flagKey: string, value: boolean) => {
      posthog.updateEarlyAccessFeatureEnrollment(flagKey, value);
    },
    isFeatureActive: (flagKey: string) => !!activeFlags?.includes(flagKey),
  };
}
